module.exports = __webpack_public_path__ + "static/media/secondary-staff.ecc3b5b3.svg";